// import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard/Dashboard';
import Admindashboard from './admindash/Admindashboard';
import Site from './pages/Site';
import Dashhome from './dashboard/Dashhome';
import Signup from './pages/Signup';
import Signin from './pages/Signin';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Corporate from './pages/Corporate';
import Donate from './pages/Donate';
import Education from './pages/Education';
import Foundation from './pages/Foundation';
import Individual from './pages/Individual';
import Locations from './pages/Locations';
import Mainpage from './pages/Mainpage';
import Program from './pages/Program';
import Admindashhome from './admindash/Admindashhome';
import Adminsignin from './pages/Adminsignin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

import { ProtectedRoute } from './components/Protectedroute';
import { AdminProtectedRoute } from './components/AdminProtectedroute';

// dash imports
import Myplants from './dashboard/pages/Myplants';
import Donatedash from './dashboard/pages/Donatedash';
import Pricing from './dashboard/pages/Pricing';
import Settings from './dashboard/pages/Settings';
import Allusers from './admindash/pages/Allusers';
import Allpayments from './admindash/pages/Allpayments';
import Usertransactions from './admindash/pages/Usertransactions';
import Contactforms from './admindash/pages/Contactforms';
import UpdateUsers from './admindash/pages/UpdateUsers';
import UpdateDonations from './admindash/pages/UpdateDonations';
import DonationConfirm from './pages/DonationConfirm';
import SignupSuccess from './pages/SignupSuccess';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import ReactGA from "react-ga4";
import ENV from './constants/env-constants';
import MySubscriptions from './dashboard/pages/MySubscriptions';

ReactGA.initialize(ENV.GOOGLE_ANALYTICS_MEASUREMENT_ID);

function App() {
  return (
    <>
    <Routes>
      
      <Route path="/" element={<Mainpage />} />
      <Route path="site" element={<Site />} >
        <Route path="about" element={<About />} />
        <Route path="blog" element={<Blog />} />
        <Route path="contact" element={<Contact />} />
        <Route path="corporate" element={<Corporate />} />
        <Route path="donate" element={<Donate />} />
        <Route path="give" element={<Donate />} />
        <Route path="support" element={<Donate />} />
        <Route path="donate/confirm" element={<DonationConfirm/>} />
        <Route path="signup/success" element={<SignupSuccess/>} />
        <Route path="subscription/success" element={<SubscriptionSuccess/>} />
        <Route path="education" element={<Education />} />
        <Route path="foundation" element={<Foundation />} />
        <Route path="individual" element={<Individual />} />
        <Route path="locations" element={<Locations />} />
        <Route path="program" element={<Program />} />

        <Route path="signup" element={<Signup />} />
        <Route path="subscribe" element={<Signup />} />
        <Route path="join" element={<Signup />} />
        <Route path="signin" element={<Signin />} />
        <Route path="change-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="adminlogin" element={<Adminsignin />} />
      </Route>

      <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
        <Route path="home" element={<Dashhome />} />
        <Route path="myplants" element={<Myplants /> } />
        <Route path="mysubscriptions" element={<MySubscriptions /> } />
        <Route path="donate" element={<Donatedash />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route path="admindashboard" element={<AdminProtectedRoute><Admindashboard /></AdminProtectedRoute>}>
        <Route path="allusers" element={<Allusers />} />
        <Route path="usertransactions/:userid" element={<Usertransactions />} />
        <Route path="allpayments" element={<Allpayments />} />
        <Route path="allforms" element={<Contactforms />} />
        <Route path="update-users" element={<UpdateUsers/>} />
        <Route path="update-donations" element={<UpdateDonations/>} />
      </Route>


    </Routes>
    </>

    

  );
}

export default App;
